module.exports = __webpack_public_path__ + "static/media/logo.65a8f75c.png";